export type HairTypeValue = string | null

export interface HairTypeOption {
    key: string
    label: string
    description: string
    tooltip: string
}

export const HAIR_TYPE_OPTIONS: HairTypeOption[] = [
    {
        key: 'liso',
        label: 'Liso',
        description: 'Sem cachos ou ondulações, da raiz às pontas',
        tooltip: 'Fio sem ondulação ou cacho natural, liso da raiz às pontas. O sebo do couro cabeludo se distribui com facilidade ao longo do fio, deixando-o oleoso mais rápido.',
    },
    {
        key: 'ondulado',
        label: 'Ondulados',
        description: 'Ondulação leve em "S", sem cachos definidos',
        tooltip: 'Fio com ondulação leve em formato de "S", sem formar cachos definidos. Tende a volume e frizz, especialmente em dias úmidos.',
    },
    {
        key: 'crespo',
        label: 'Crespo',
        description: 'Cachos bem definidos e apertados, alta porosidade',
        tooltip: 'Fio com cachos bem definidos e apertados (formato de mola ou ziguezague). Alta porosidade e tendência a ressecamento — precisa de mais hidratação.',
    },
]

export function findHairType(key: HairTypeValue): HairTypeOption | null {
    return HAIR_TYPE_OPTIONS.find((option) => option.key === key) ?? null
}

export function isHairTypeValueEmpty(value: HairTypeValue | undefined): boolean {
    return !value
}
